export default "__VITE_ASSET__D7mo4gUd__"